import { Link, NavLink, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import ThemeToggle from "@/components/ThemeToggle";

const links = [
  { to: "/category/sides", label: "Sides" },
  { to: "/category/mains", label: "Main Course" },
  { to: "/category/desserts", label: "Desserts" },
  { to: "/shop", label: "Shop" },
];

export default function Navigation() {
  const location = useLocation();
  const isRecipe = location.pathname.startsWith("/recipe/");

  return (
    <motion.header
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      data-testid="site-navigation"
      className="fixed top-0 left-0 right-0 z-40 backdrop-blur-xl bg-background/85 border-b border-border/50"
    >
      <div className="max-w-[1600px] mx-auto flex items-center justify-between px-6 md:px-12 py-5">
        <Link
          to="/"
          data-testid="nav-logo-link"
          className="font-display text-2xl md:text-3xl tracking-tighter text-foreground hover:text-accent transition-colors duration-300"
        >
          Scrollinary<span className="text-accent">.</span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              data-testid={`nav-link-${link.to.split("/").pop()}`}
              className={({ isActive }) =>
                `font-serif-alt text-lg tracking-wide transition-all duration-300 relative ${
                  isActive
                    ? "text-accent"
                    : "text-foreground/80 hover:text-accent"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {link.label}
                  {isActive && (
                    <motion.span
                      layoutId="nav-underline"
                      className="absolute -bottom-1 left-0 right-0 h-[1px] bg-accent"
                    />
                  )}
                </>
              )}
            </NavLink>
          ))}
          <ThemeToggle />
        </nav>

        {/* Mobile: compact links */}
        <nav className="flex md:hidden items-center gap-4">
          {links.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              data-testid={`nav-link-mobile-${link.to.split("/").pop()}`}
              className={({ isActive }) =>
                `font-serif-alt text-sm ${isActive ? "text-accent" : "text-foreground/70"}`
              }
            >
              {link.label.split(" ")[0]}
            </NavLink>
          ))}
          <ThemeToggle />
        </nav>
      </div>
      {isRecipe && (
        <div className="h-[1px] bg-gradient-to-r from-transparent via-accent/40 to-transparent" />
      )}
    </motion.header>
  );
}
